module.exports = __webpack_public_path__ + "static/media/3-Ways-To-Get-FREE-Car-Removal-Service.3d628271.jpg";